import { render, staticRenderFns } from "./MovieSubcategoriesL2ForBeginnersManagement.vue?vue&type=template&id=a1f1c7ae&scoped=true&"
import script from "./MovieSubcategoriesL2ForBeginnersManagement.vue?vue&type=script&lang=js&"
export * from "./MovieSubcategoriesL2ForBeginnersManagement.vue?vue&type=script&lang=js&"
import style0 from "./MovieSubcategoriesL2ForBeginnersManagement.vue?vue&type=style&index=0&id=a1f1c7ae&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1f1c7ae",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VAlert,VBtn,VCard,VCardTitle,VDataTable,VSpacer,VTextField,VTooltip})
